(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zelink-campaign-strip"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.zcampaign[data-campaign-end]').forEach(bar=>{
  const deadline=Date.parse(bar.dataset.campaignEnd);
  if(!Number.isFinite(deadline))return;
  const clock=bar.querySelector('.zcampaign__clock');
  let timer;
  const update=()=>{
    const remaining=Math.floor((deadline-Date.now())/1000);
    if(remaining<=0){bar.hidden=true;clearInterval(timer);return;}
    const values={days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};
    Object.entries(values).forEach(([key,value])=>{clock.querySelector('[data-time="'+key+'"]').textContent=String(value).padStart(2,'0');});
    clock.hidden=false;
  };
  update();
  if(!bar.hidden)timer=setInterval(()=>{if(!bar.isConnected){clearInterval(timer);return;}update();},1000);
});
  } catch(e) { console.error(e); }
})();

})();
